<template>
  <div class="fab-notification">
    <div class="icon">
      <v-avatar style="float:left;" class="mt-0 mr-2" :color="severity" size="30px">
        <v-icon small dark>{{ icon }}</v-icon>
      </v-avatar>
    </div>

    <div class="message">
      <div class="header">
        <div class="title">
          <h4 style="line-height:1.3em">{{ notification.title }}</h4>
        </div>
        <div class="actions">
          <v-tooltip bottom>
            <div slot="activator" class="body-1 opacity-54"
              style="display:inline-flex; cursor: pointer;">{{ timestamp
              }}
            </div>
            <span>{{ fullDate }}</span>
          </v-tooltip>
          <v-btn @click="clearNotification()" dark small class="mr-0 ml-2" icon>
            <v-icon small color="white">cancel</v-icon>
          </v-btn>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" dark small class="mr-0 ml-0 pa-0" icon>
                <v-icon small color="white">more_vert</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-tile v-if="caseSubs" @click="disableNotifications">
                <v-icon class="mr-2" color="secondary">notifications_off</v-icon>Turn off notifications on this case
              </v-list-tile>
              <v-list-tile v-if="notification.caseId" :to="{ path: casePreferencesRoute(notification.caseId) }">
                <v-icon class="mr-2" color="secondary">notifications_active</v-icon>Edit notifications on this case
              </v-list-tile>
              <v-list-tile v-else :to="{ path: userPreferencesRoute(userId) }">
                <v-icon class="mr-2" color="secondary">notifications_active</v-icon>Edit notifications
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
      <div class="message">
        <span class="body-1 opacity-54">{{ notification.message }}</span>
      </div>
    </div>
  </div>
  <!-- <v-layout row wrap pa-2>
    <v-flex xs9 pl-1>
      <div style="display:table-cell; vertical-align:middle;">
        <v-avatar style="float:left;" class="mt-0 mr-2" :color="severity" size="30px">
          <v-icon small dark>{{ icon }}</v-icon>
        </v-avatar>
      </div>
      <div style="display:table-cell" class="pl-1">
        <h4 style="line-height:1.3em">{{ notification.title }}</h4>
        <span class="body-1 opacity-54">{{ notification.message }}</span>
      </div>
    </v-flex>
    <v-flex xs3 text-xs-right class="mt-0">
      <v-tooltip bottom>
        <div slot="activator" class="body-1 opacity-54"
          style="display:inline-flex; vertical-align:top !important; margin-top:9px; cursor: pointer;">{{ timestamp }}
        </div>
        <span>{{ fullDate }}</span>
      </v-tooltip>
      <v-btn @click="clearNotification()" dark small class="mr-0 ml-2" icon>
        <v-icon small color="white">cancel</v-icon>
      </v-btn>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" dark small class="mr-0 ml-0 pa-0" icon>
            <v-icon small color="white">more_vert</v-icon>
          </v-btn>
        </template>
<v-list dense>
  <v-list-tile v-if="caseSubs" @click="disableNotifications">
    <v-icon class="mr-2" color="secondary">notifications_off</v-icon>Turn off notifications on this case
  </v-list-tile>
  <v-list-tile v-if="notification.caseId" :to="{ path: casePreferencesRoute(notification.caseId) }">
    <v-icon class="mr-2" color="secondary">notifications_active</v-icon>Edit notifications on this case
  </v-list-tile>
  <v-list-tile v-else :to="{ path: userPreferencesRoute(userId) }">
    <v-icon class="mr-2" color="secondary">notifications_active</v-icon>Edit notifications
  </v-list-tile>
</v-list>
</v-menu>
</v-flex>
</v-layout> -->
</template>

<script>
import { mapState } from 'vuex'
import Helpers from '@/helpers.js'
export default {
  name: "fab-notification",
  props: { notification: Object, icon: String },
  data: () => ({
    expandDetail: false
  }),
  computed: {
    ...mapState({
      userId: state => state.currentUser.me.id,
      subscriptions: state => state.currentUser.subscriptions
    }),
    caseSubs() {
      if (this.notification.caseId) {
        const subs = this.subscriptions.filter((sub) => sub.case.id === this.notification.caseId)
        if (subs.length > 0) {
          return subs
        } else {
          return undefined
        }
      } else {
        return undefined
      }
    },
    severity() {
      switch (this.notification.severity) {
        case "info": return 'info'
        case "error": return 'error'
        default: return 'tertiary'
      }
    },
    timestamp() { return Helpers.formatDate(this.notification.createdAt, "hh:mm") },
    fullDate() {
      return Helpers.formatDate(this.notification.createdAt, 'dddd, Do MMMM YYYY, h:mma')
    },
    allEvents: {
      get() {
        return (this.updateEvent && this.statusEvent && this.taskEvent && this.documentEvent && this.conversationEvent && this.createEvent && this.viewEvent)
      },
      set(value) {
        this.updateEvent = value
        this.statusEvent = value
        this.taskEvent = value
        this.documentEvent = value
        this.conversationEvent = value
        this.createEvent = value
        this.viewEvent = value
      }
    }
  },
  methods: {
    userPreferencesRoute: (userId) => `/users/${userId}/Notifications`,
    casePreferencesRoute: (caseId) => `/case/${caseId}/timeline`,
    async disableNotifications() {
      const updateUnSubs = this.caseSubs.map((sub) => sub.eventType)
      const success = await this.$store.dispatch("unsubscribeFromCaseEvents", { caseId: parseInt(this.notification.caseId), eventTypes: updateUnSubs })
      if (success) { // if all succeeded
        this.$store.commit("displayFlashMessage", { message: "Successfully cleared all notification subscriptions on case", severity: "success" })
      }
    },
    async clearNotification() {
      await this.$store.dispatch("clearNotification", parseInt(this.notification.id))
    }
  }
}
</script>

<style lang="scss" scoped>
.fab-notification {
  display: flex;
  flex-direction: row;
  align-items: top;
  justify-content: center;
  gap: 10px;
  padding: 10px;


  .icon {
    margin-left: 5px;
    margin-top: 2px;
  }
  .message {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 5px;
    flex: 1;
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;

    .title {
      flex: 1;
      h4 {
        margin: 0;
      }
    }
  }
}
</style>